import { createMqStyles, tokens } from '@fhs/ui';

export const useDeliveryPanelMqStyles = createMqStyles({
  root: {
    $base: {
      flex: 1,
    },
  },
  scroll: {
    $base: {
      flex: 1,
    },
  },
  scrollContent: {
    $base: {
      flexGrow: 1,
    },
  },
  /**
   * The toggle above already pads 8 below itself on mobile and 24 on desktop, and the design
   * leaves 24 between the toggle and "Delivery Powered By" on both, so only mobile adds a top.
   */
  addressBlock: {
    $base: {
      gap: 12,
      paddingBottom: 16,
      paddingHorizontal: 16,
      paddingTop: 16,
      // Suggestions are absolutely positioned and overflow this block, so it has to stack
      // above the saved addresses that follow it.
      zIndex: 1,
    },
    $gteDesktop: {
      gap: 24,
      paddingBottom: 24,
      paddingHorizontal: 32,
      paddingTop: 0,
    },
  },
  // Same reason, one level in: the suggestions also have to cover the terms notice below.
  addressField: {
    $base: {
      gap: 12,
      zIndex: 1,
    },
  },
  // Mobile rules the button off from the scrolling content; desktop sets it on the panel's white
  // with the same insets as the store details CTA.
  footer: {
    $base: {
      backgroundColor: tokens.colors.$white,
      borderTopColor: tokens.colors.$black10,
      borderTopWidth: 1,
      paddingHorizontal: 16,
      paddingTop: 16,
    },
    $gteDesktop: {
      borderTopWidth: 0,
      paddingBottom: 32,
      paddingHorizontal: 32,
      paddingTop: 24,
    },
  },
  // The solid button's resting colors.
  deliverHereAtRest: {
    $base: {
      backgroundColor: tokens.colors.$houseRed,
      borderColor: tokens.colors.$houseRed,
    },
  },
});
